// extracted by mini-css-extract-plugin
export default {"theme":"Theme_theme__hrgiE","input":"Theme_input__ZbgxM","inner":"Theme_inner__GxBJx","box":"Theme_box__JAqn3"};